export default __webpack_public_path__ + "static/petiteMaro4.inspirations-57755f61215807aca625bfa61aca4544.jpg";